import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
@Injectable({
  providedIn: 'root',
})
export class RestAPIService {
    constructor(private http: HttpClient, private router: Router, private authService: AuthService) {}
    public loading : boolean = false;
    get<T>(url: any,options: any = null): Observable<any> {
      if(options)
        return this.http.get<T>(url,options).pipe(retry(0), catchError(this.handleError));
      else
        return this.http.get<T>(url).pipe(retry(0), catchError(this.handleError));
    }

    getFile(url: any): Observable<any> {
      return this.http.get(url, { responseType: 'blob', observe: 'response' }).pipe(retry(0), catchError(this.handleError));
    }
    
    post<T>(url: any, body: any): Observable<T> {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
        return this.http
            .post<T>(
                url,
                JSON.stringify(body),
                {headers}
            ).pipe(retry(0), catchError(this.handleError));
    }

    postFormData<T>(url: any, body: FormData): Observable<T> {
        return this.http
            .post<T>(
                url,
                body
            ).pipe(retry(0), catchError(this.handleError));
    }

    put<T>(url: any, body: any): Observable<T> {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
        return this.http
            .put<T>(
                url,
                JSON.stringify(body),
                {headers}
            )
            .pipe(retry(0), catchError(this.handleError));
    }

    putFormData<T>(url: any, body: FormData): Observable<T> {
        return this.http
            .put<T>(
                url,
                body
            )
            .pipe(retry(0), catchError(this.handleError));
    }

    delete<T>(url: any, body: string): Observable<T> {
        return this.http
            .delete<T>(url)
            .pipe(retry(0), catchError(this.handleError));
    }

    // Error handling
  handleError = (error: any) => {
    let errorMessage = '';
    if (error.status === 401) {
      // Unauthorized: redirect to login
      //this.authService.logout();
      this.router.navigate(['/unauthorized']);
      errorMessage = 'Unauthorized access. Redirecting to unauthorized...';
    } else if (error.error && error.error.Message) {
      errorMessage = error.error.Message;
    } else if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}